import { FC } from "react";
import { WorkDTO } from "../../../../domain/models/dto/WorkDTO";
import WorkStatusLabel from "./WorkStatusLabel";
import ExpiresInTimerLabel from "./ExpiresInTimerLabel";
import { isExpressWork } from "../../../../slices/works-slice";

interface WorkLabelsProps {
    work: WorkDTO;
    biggerVersion?: boolean;
    showPersonalApplicationStatus?: boolean;
}

const WorkLabels: FC<WorkLabelsProps> = (props) => {
    return (
        <div className="flex tmax4:flex-col items-start justify-between tmin4:gap-4 tmax4:gap-2">
            <WorkStatusLabel
                work={props.work}
                biggerVersion={props.biggerVersion}
                showPersonalApplicationStatus={props.showPersonalApplicationStatus}
            />
            {isExpressWork(props.work) && <ExpiresInTimerLabel work={props.work} biggerVersion={props.biggerVersion} />}
        </div>
    );
};

export default WorkLabels;
